// extracted by mini-css-extract-plugin
export default {"wrapper":"Yp-z","response":"Zp-z","error":"_p-z","disabled":"aq-z","buttons":"bq-z","feedbackQuestionSection":"cq-z","yesNoWrapper":"dq-z"};